import { Link } from 'react-router-dom';
import { getPerson } from '@/utils/content';
import type { CaseItem } from '@/types/content';
import HeatBadge from '@/components/base/HeatBadge';

interface TodayMainProps {
  item: CaseItem;
}

export default function TodayMain({ item }: TodayMainProps) {
  const people = item.personIds.map((id) => getPerson(id)).filter(Boolean);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-smile-line" />
            </span>
            今日主瓜
          </span>
          <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950 leading-snug">
            {item.title}
          </h2>
          <p className="mt-2 text-sm md:text-base text-primary-600 font-medium">{item.subtitle}</p>
          <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">{item.summary}</p>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            {item.tags.map((tag) => (
              <span key={tag} className="px-2.5 py-1 rounded-full bg-background-200 text-foreground-700 text-xs whitespace-nowrap">
                #{tag}
              </span>
            ))}
          </div>

          <div className="mt-6 flex items-center gap-4 flex-wrap">
            <HeatBadge heat={item.heat} size="md" />
            <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line" />
              {item.views} 阅读
            </span>
            <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
              <i className="ri-time-line" />
              {item.date}
            </span>
          </div>

          <div className="mt-7 flex items-center gap-4 flex-wrap">
            <Link
              to={`/case/${item.id}`}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-git-branch-line" />
              查看完整关系图
            </Link>
            <div className="flex items-center gap-3">
              <div className="flex items-center -space-x-2">
                {people.slice(0, 4).map((person) => (
                  <img
                    key={person!.id}
                    src={person!.avatar}
                    alt={`${person!.name} 头像`}
                    title={`${person!.name} - ${item.title}`}
                    className="w-9 h-9 rounded-full object-cover object-top border-2 border-background-50"
                  />
                ))}
              </div>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.personIds.length} 位关联人物</span>
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <Link to={`/case/${item.id}`} className="block relative rounded-lg overflow-hidden group cursor-pointer">
            <img
              src={item.cover}
              alt={`${item.title} 事件主视觉`}
              title={`${item.title} - 911吃瓜`}
              className="w-full h-64 md:h-[420px] object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-primary-950/90 to-transparent">
              <p className="text-background-50 text-sm md:text-base font-medium">
                从同款细节到时间线复盘，一张图看懂这段关系的来龙去脉。
              </p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}